import React from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "180px",
  borderRadius: "10px",
};

const ShopMap = ({ shopData }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyDqs07ua04jy-Zz_nYm6GMvOo6WgKZrWNI", // ✅ your API key
  });

  const center = {
    lat: shopData?.latitude || 33.6995,
    lng: shopData?.longitude || 73.0423,
  };

  if (!isLoaded) return <div>Loading map...</div>;

return (
  <>
    <div className="rounded shadow-sm overflow-hidden mb-2">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
        options={{
          disableDefaultUI: true,
          zoomControl: true,
        }}
      >
        <Marker position={center} />
      </GoogleMap>
    </div>

    <div className="d-flex justify-content-between">
      <p className="mb-0 fw-semibold">
        Lat: {shopData?.latitude || "33.6995"}
      </p>
      <p className="mb-0 fw-semibold">
        Long: {shopData?.longitude || "73.0423"}
      </p>
    </div>
  </>
);
};

export default ShopMap;
